/*
 * @Author: freedeng
 * @Date: 2019-07-19 10:41:24
 * @Last Modified by: paddywu
 * @Last Modified time: 2019-11-23 11:02:41
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MutexLock, LockStrategy, } from './MutexLock';
import { DEBUG } from '../Constant';
import { Result, JSApi, BaseError } from '@tencent/tdoc-database';
var ClientMutexLock = /** @class */ (function (_super) {
    __extends(ClientMutexLock, _super);
    function ClientMutexLock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClientMutexLock.prototype.getDefaultConfig = function () {
        return {
            strategy: LockStrategy.ONCE,
            period: -1,
            autoRenewal: true,
        };
    };
    ClientMutexLock.prototype.lock = function (key, optional) {
        return __awaiter(this, void 0, void 0, function () {
            var item, req, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        item = { tabId: this.tabId, expire: this.period === -1 ? -1 : Date.now() + this.period, optional: optional };
                        req = {
                            command: 'lock',
                            key: key,
                            item: item,
                        };
                        this.logRequest(req);
                        return [4 /*yield*/, new Promise(function (resolve) {
                                var success = function (res) {
                                    _this.logResponse(res);
                                    if (res.err_msg || res.err_code) {
                                        var error = new Error(res.err_msg || res.err_code);
                                        resolve(new Result(error));
                                    }
                                    else {
                                        resolve(new Result(undefined, res.result));
                                    }
                                };
                                _this.getClientMutexLock(req, success);
                            })];
                    case 1:
                        result = _a.sent();
                        if (result.error) {
                            return [2 /*return*/, { isSuccess: false, data: result.data }];
                        }
                        if (result.data.tabId === this.tabId) {
                            // 成功
                            return [2 /*return*/, { isSuccess: true, data: result.data }];
                        }
                        return [2 /*return*/, { isSuccess: false, data: result.data }];
                }
            });
        });
    };
    ClientMutexLock.prototype.detectKey = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var req, clientResult, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        req = {
                            command: 'detectKey',
                            key: key,
                        };
                        this.logRequest(req);
                        return [4 /*yield*/, new Promise(function (resolve) {
                                var success = function (res) {
                                    _this.logResponse(res);
                                    resolve(res);
                                };
                                _this.getClientMutexLock(req, success);
                            })];
                    case 1:
                        clientResult = _a.sent();
                        result = new Result(undefined, clientResult.result);
                        if (clientResult.err_code) {
                            // deteckKey异常
                            result.error = new BaseError("" + clientResult.err_code);
                            return [2 /*return*/, result];
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * 释放锁
     * @param key
     */
    ClientMutexLock.prototype.release = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var req, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        req = {
                            command: 'release',
                            key: key,
                        };
                        this.logRequest(req);
                        return [4 /*yield*/, new Promise(function (resolve) {
                                var success = function (res) {
                                    _this.logResponse(res);
                                    if (res.err_msg || res.err_code) {
                                        var error = new Error(res.err_msg || res.err_code);
                                        resolve(new Result(error));
                                    }
                                    else {
                                        resolve(new Result(undefined, res.result));
                                    }
                                };
                                _this.getClientMutexLock(req, success);
                            })];
                    case 1:
                        result = _a.sent();
                        if (result.error) {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, true];
                }
            });
        });
    };
    ClientMutexLock.prototype.getClientMutexLock = function (req, success) {
        var _a;
        if ((_a = global.tdocs) === null || _a === void 0 ? void 0 : _a.getClientMutexLock) {
            global.tdocs.getClientMutexLock(__assign(__assign({}, req), { success: success }));
        }
        else {
            JSApi.invokeNative('docx', 'clientMutexLock', req, success);
        }
    };
    ClientMutexLock.prototype.logRequest = function (req) {
        if (DEBUG) {
            console.log('-----ClientMutexLockReqeust', req);
        }
    };
    ClientMutexLock.prototype.logResponse = function (req) {
        if (DEBUG) {
            console.log('-----ClientMutexLockReqeust', req);
        }
    };
    return ClientMutexLock;
}(MutexLock));
export default ClientMutexLock;
export { ClientMutexLock };
//# sourceMappingURL=ClientMutexLock.js.map